/**
 * URL utility functions
 */

/**
 * Sanitizes sensitive OAuth parameters from URLs for secure logging
 * Replaces sensitive parameter values with '[REDACTED]'
 * @param url - The URL to sanitize
 * @returns The sanitized URL, or original URL if parsing fails
 */
export const sanitizeUrl = (url: string): string => {
  if (!url) return url;

  try {
    const urlObj = new URL(url);
    const sensitiveParams = ['code', 'access_token', 'refresh_token', 'id_token'];
    sensitiveParams.forEach(param => {
      if (urlObj.searchParams.has(param)) {
        urlObj.searchParams.set(param, '[REDACTED]');
      }
    });
    return urlObj.toString();
  } catch (error) {
    // Return original URL if parsing fails - better to log something than nothing
    return url;
  }
}; 